import * as React from 'react';
import { createGlobalStyle, ThemeProvider } from 'styled-components';
import theme from '../../styles/theme';

const GlobalStyle = createGlobalStyle`
  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed, 
  figure, figcaption, footer, header, hgroup, 
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    font: inherit;
    vertical-align: baseline; 
  }

  html {
    font-size: 62.5%;
    font-family: ${(props) => props.theme.font.primary};
  }

  body {
    min-height: 100vh;
  }

  article, aside, details, figcaption, figure, 
  footer, header, hgroup, menu, nav, section {
    display: block;
  }
  body {
    line-height: 1;
    .modal {
      visibility: hidden;
      transition: all 0.3s ease 0s;
      opacity: 0;
    }
    .show {
      visibility: visible;
      opacity: 1;
      height: 100vh;
    }
  }
  ol, ul {
    list-style: none;
  }
  blockquote, q {
    quotes: none;
  }
  blockquote:before, blockquote:after,
  q:before, q:after {
    content: '';
    content: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
  *, *:before, *:after {
    box-sizing: border-box;
  }
  *, *:focus {
    outline: none;
  }
 img {
  max-width:100%;
 }
`;

export const Layout = ({ children }) => (
  <ThemeProvider theme={theme}>
    <React.Fragment>
      {children}
      <GlobalStyle />
    </React.Fragment>
  </ThemeProvider>
);
